import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstallationActions',
    props: {
        status: null,
        isBusy: { type: Boolean }
    },
    emits: ["onInstall", "onUninstall", "onReset"],
    setup(__props, { emit }) {
        const props = __props;
        const installState = computed(() => !props.status || props.status === "Uninstalled");
        const uninstallState = computed(() => props.status === "Installed");
        function onReset() {
            if (window.confirm(`Do you want to reset this repository?`)) {
                emit("onReset");
            }
        }
        return { __sfc: true, props, installState, uninstallState, emit, onReset, localize };
    }
});
